var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 84,
    viewBox: "0 0 121 84",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 120,
    height: 84,
    rx: 13.5,
    fill: "#FF9E67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 30.5056V56.5056M60.5 30.5056C58.1642 28.9537 54.993 28 51.5 28C48.007 28 44.8358 28.9537 42.5 30.5056V56.5056C44.8358 54.9537 48.007 54 51.5 54C54.993 54 58.1642 54.9537 60.5 56.5056M60.5 30.5056C62.8358 28.9537 66.007 28 69.5 28C72.993 28 76.1642 28.9537 78.5 30.5056V56.5056C76.1642 54.9537 72.993 54 69.5 54C66.007 54 62.8358 54.9537 60.5 56.5056",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeBox);
export default __webpack_public_path__ + "static/media/orangeBox.700197b2f5b575416b76ded276df7ed6.svg";
export { ForwardRef as ReactComponent };